import { Injectable } from '@angular/core';
import { BBService } from 'bookingbug-core-js';
import { AppConfig } from 'src/app/app.config';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DepartmentService {
  private core = AppConfig.settings.core;
  private apiServer = AppConfig.settings.apiServer;
  parentDepartment;
  selectedDepartment;
  selectedLocation;
  locationsList;

  constructor(
    private http: HttpClient
  ) { }

  async getParentDepartment() {
    return await BBService.company.query(parseInt(this.core.company_id), { excludeChildCompanies: false });
  }

  async getChildDepartments(parentDepartment) {
    return await parentDepartment.$getChildren();
  }

  async set(department) {
    this.selectedDepartment = department;
  }

  async get() {
    return this.selectedDepartment;
  }

  // Get the list of locations from the selected department.
  // First check if a call was already made and we already have 
  // the locations
  async getSelectedDepartmentChildren() {
    const locations = await this.getLocationList();
    if (locations) {
      return locations;
    } else {
      return await this.selectedDepartment.$getChildren();
    }
  }

  async setLocationList(locations) {
    this.locationsList = locations;
  }

  async getLocationList() {
    return this.locationsList;
  }

  async setLocation(location) {
    this.selectedLocation = location;
  }

  async getLocation() {
    return this.selectedLocation;
  }

  async getCustomerQuestions(selectedDepartment = null) {
    const headers: HttpHeaders = new HttpHeaders({
      'App-Id': this.core.app_id
    });

    // passing in the selectedDepartment to be used for MyAccount page as we dont want to change the global selectedDepartment
    let selectedDepartmentInfo = selectedDepartment ? selectedDepartment : this.selectedDepartment

    const apiUrl = `${this.apiServer.api_url}/api/${this.apiServer.version}/${selectedDepartmentInfo.id}/client_details`;
    const details = await this.http.get(apiUrl, { headers }).toPromise();
    return details['questions'];
  }
}
